import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';

import { useNotifications } from '../../common/hooks/useNotifications';
import { usePokCore } from '../../common/hooks/usePokCore';
import { useTranslation } from '../../common/hooks/useTranslation';

import { getPdf } from './getPdf';

export const ProceduresPLView: React.FC = () => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('menuLng');

  const getTempPdf = (name: string) => {
    getPdf(pok, notifications, name);
  };

  return (
    <>
      <Card className="main-card">
        <Card.Body className="m-3">
          <Card.Title className="pb-3">{t(tk.menu.procedures)}</Card.Title>
          <div className="d-grid gap-2">
            <Row>
              <Col md={6}>
                <div className="d-grid gap-2">
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf(
                        'instructions/pl/POK - Procedura dodawania i akceptacji faktur zakupu.pdf',
                      )
                    }
                  >
                    {t(tk.docs.addingPurchaseInvoices)}
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="lg"
                    onClick={() =>
                      getTempPdf(
                        'instructions/pl/Prezentacja_procedura_WHT_2024.pdf',
                      )
                    }
                  >
                    {t(tk.docs.settlementWithholdingTax)}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
